import { useState, useContext } from 'react';

import endpoints from '../../../../api/endpoints';
import { nortadaLogger } from '../../../common/logger';
import { DOM_EXCEPTION_CODES } from '../../../../constants/errors';
import { handleResponseError } from '../../../../api/handleResponseError';
import { ToastNotificationContext } from '../../../common/toast-notification';
import { fetchWithTokenRefresh } from '../../../../api/fetchWithTokenRefresh';

import { CLIENT_BALANCE_ERROR_MSG } from './consts';
import { ClientBalanceAmount, ClientBalance, GetClientBalance } from './interfaces';

export const useClientBalance = () => {
  const { openToast } = useContext(ToastNotificationContext);
  const [isClientBalanceError, setIsClientBalanceError] = useState<boolean>(false);
  const [clientBalance, setClientBalance] = useState<ClientBalance>({
    pendingCredits: null,
    pendingDebits: null,
    balance: null
  });

  const handleAmountAvailability = (amount?: ClientBalanceAmount): ClientBalanceAmount => {
    if (amount === undefined) {
      return null;
    }

    return amount;
  };

  const getClientBalance: GetClientBalance = type => {
    if (type === 'all') {
      return clientBalance;
    }

    return clientBalance[type];
  };

  const updateClientBalance = async () => {
    try {
      const response = await fetchWithTokenRefresh(endpoints.clientBalance);

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const jsonResponse = await response.json();

      const responsePendingDebits = handleAmountAvailability(jsonResponse?.pendingDebits);
      const responsePendingCredits = handleAmountAvailability(jsonResponse?.pendingCredits);
      const responseAvailableFunds = handleAmountAvailability(jsonResponse?.available);

      setClientBalance({
        pendingDebits: responsePendingDebits,
        pendingCredits: responsePendingCredits,
        balance: responseAvailableFunds
      });
    } catch (e) {
      if (e.code !== DOM_EXCEPTION_CODES.ABORT_ERROR) {
        setIsClientBalanceError(true);
        openToast({
          message: CLIENT_BALANCE_ERROR_MSG,
          severity: 'error',
          closeOnClickOnly: true
        });

        nortadaLogger.error(e);
      }
    }
  };

  return { isClientBalanceError, updateClientBalance, getClientBalance };
};
